// De status van een persoon als pil (W9; sinds W6 ronde 7 een eigen module).
//
// Staat apart zodat Gebruikers.tsx (Mensen), GebruikersGebruik.tsx (Gebruik) en
// KostenCredits.tsx (Kosten & credits) hem alle drie van één plek lezen, zonder
// dat Gebruikers.tsx en GebruikersGebruik.tsx elkaar in een kring importeren.

import { color, radius, size, weight } from "../../tokens";
import { statusUitleg } from "./woorden";

/** De status als pil, met de uitleg uit woorden.ts in de tooltip. Ook de
 *  creditstabel van Kosten & credits toont hem (daar is de status een losse
 *  tekst van de server), dus een status buiten de lijst krijgt geen kleur en
 *  geen verzonnen uitleg — alleen zijn woord. */
export function StatusPil({ status }: { status: string }) {
  const kleur =
    status === "actief"
      ? { tekst: color.accentGreen, vlak: "#ecfdf5" }
      : status === "inactief"
        ? { tekst: color.accentRed, vlak: "#fef2f2" }
        : { tekst: color.soft, vlak: color.lineFaint };
  const uitleg = statusUitleg(status);
  return (
    <span
      title={uitleg ?? undefined}
      style={{
        background: kleur.vlak,
        color: kleur.tekst,
        borderRadius: radius.pill,
        padding: "3px 9px",
        fontSize: size.label,
        fontWeight: weight.medium,
      }}
    >
      {status}
    </span>
  );
}
